import { LOCAL_AUTH_STORAGE_KEYS } from '../constants'

const canUseStorage = () => typeof localStorage !== 'undefined'

export const getStoredAccessToken = () => {
  if (!canUseStorage()) return ''

  return localStorage.getItem(LOCAL_AUTH_STORAGE_KEYS.token) || ''
}

export const setStoredAccessToken = (token: string) => {
  if (!canUseStorage()) return

  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.token, token)
}

export const clearStoredAccessToken = () => {
  if (!canUseStorage()) return

  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.token)
}

export const getStoredRefreshToken = () => {
  if (!canUseStorage()) return ''

  return (
    localStorage.getItem(LOCAL_AUTH_STORAGE_KEYS.refreshToken) ||
    getStoredAccessToken()
  )
}

export const setStoredRefreshToken = (refreshToken: string) => {
  if (!canUseStorage()) return

  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.refreshToken, refreshToken)
}

export const getStoredAccountId = () => {
  if (!canUseStorage()) return ''

  return localStorage.getItem(LOCAL_AUTH_STORAGE_KEYS.accountId) || ''
}

export const setStoredAccountId = (accountId: string) => {
  if (!canUseStorage()) return

  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.accountId, accountId)
}

export const clearStoredAuth = () => {
  if (!canUseStorage()) return

  clearStoredAccessToken()
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.refreshToken)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.user)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.userDisplayName)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.email)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.accountId)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.firstLogin)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.pendingLoginEmail)
  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.webpushUrl)
}
